//@ts-ignore
import { ItalyFlagIcon } from "@vueEntry/SvgIcons/ItalyFlagIcon";
//@ts-ignore
import { GermanyFlagIcon } from "@vueEntry/SvgIcons/GermanyFlagIcon";
//@ts-ignore
import { UkFlagIcon } from "@vueEntry/SvgIcons/UkFlagIcon";
export default {
  ItalyFlagIcon,
  GermanyFlagIcon,
  UkFlagIcon
};